import { Api } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { Toast } from "@mcleod/components";
import { AutogenLayoutTestEmailSettings } from "./autogen/AutogenLayoutTestEmailSettings";
import { EmailSettings } from "./EmailSettings";

/**
 * This class offers a simple panel that allows a test email to be sent based on the values in a provided EmailSettings
 * layout.  It is intended to be displayed in a Yes/No Dialog (via TestEmailSettingsDisplayer).
 */
export class TestEmailSettings extends AutogenLayoutTestEmailSettings {
    private _layoutEmailSettings: EmailSettings;

    public get layoutEmailSettings(): EmailSettings {
        return this._layoutEmailSettings;
    }

    public set layoutEmailSettings(value: EmailSettings) {
        if (this._layoutEmailSettings === value) {
            return;
        }
        this._layoutEmailSettings = value;
        this.textboxFrom.text = this.layoutEmailSettings?.textboxEmail?.text ?? "";
    }

    async sendTestEmail() {
        if (this.layoutEmailSettings == null) {
            return;
        }
        await Api.post("common/email/send-email", this.testEmailInputs);
        Toast.showSuccessToast("Test Email Sent", null, ImageName.envelopeUnread);
    }

    private get testEmailInputs(): any {
        return {
            test_email_from: this.textboxFrom.text,
            test_email_host: this.layoutEmailSettings.textboxEmailHost.text,
            test_email_protocol: this.layoutEmailSettings.textboxEmailProtocol.text,
            test_email_port: this.layoutEmailSettings.textboxEmailPort.text,
            test_email_user: this.layoutEmailSettings.textboxEmailUsername.text,
            test_email_password: this.layoutEmailSettings.textboxEmailPassword.text,
            to_address: this.textboxTo.text,
            cc_address: this.textboxCC.text,
            subject: this.textboxSubject.text,
            plain_text: this.textboxMessage.text
        };
    }
}
